import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { prepareEmailRule, requiredRule } from "@rmp/core/utils/validation";
import RmpSignInFormBase from "@rmp/core/components/form/RmpSignInFormBase.vue";
import { useI18n } from "vue-i18n-composable";
import { useRoute } from "vue-router/composables";
import { useColors } from "@rmp/core/composables/useColors";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useForm } from "@rmp/core/composables/useForm";
import { usePage } from "@rmp/core/composables/usePage";
import { useForgotPasswordStore } from "@rmp/id/stores/forgotPassword";
import { AuthPageModeType } from "@rmp/core/types/authorization/authPageModeType";
import RmpLink from "@rmp/core/components/common/RmpLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpForgotPassword',
  setup(__props) {

const { tc } = useI18n();
const route = useRoute();
const { colors } = useColors();

const useStore = useForgotPasswordStore;
const store = useStore();
const { save } = store;
const { mode, email } = storeToRefs(store);

const timer = ref(0);

const handleSave = async () => {
	await save();

	if(mode!.value === AuthPageModeType.SUCCESS)
		startTimer();
};
const startTimer = () => {
	if(timer.value > 0) return;
	
	timer.value = 60;
	
	const interval = setInterval(() => {
		timer.value--;
		if(timer.value <= 0) clearInterval(interval);
	}, 1000);
};

const validation = {
	email: [requiredRule(), prepareEmailRule()]
};

const {
	form,
	formStateLoading,
	formReadonly,
	formDisabled,
	formSaving,
	formValid,
	submit
} = useForm({ useStore }, true);

const { initialized, loading } = usePage({ useStore });

return { __sfc: true,tc, route, colors, useStore, store, save, mode, email, timer, handleSave, startTimer, validation, form, formStateLoading, formReadonly, formDisabled, formSaving, formValid, submit, initialized, loading, RmpText, RmpBtn, RmpTextField, RouteNames, RmpSignInFormBase, AuthPageModeType, RmpLink }
}

})